/**
 * This mixin adds functionality to a list of objects to export the values as a
 * CSV file. This supports hiding, renaming, and filtering of the items.
 */
import filterable from './filterable.mixin.js';
import { exportCsv } from '../../utility/export.js';

export default {
  props: {
    hide: {
      type: Array,
      default() {
        return [];
      },
    },
    rename: {
      type: Object,
      default() {
        return {};
      },
    },
    exportable: {
      type: Boolean,
    },
    exportName: {
      type: String,
      default: () => 'output',
    },
    exportItems: {
      type: Array,
      default() {
        return [];
      },
    },
    isExportData: {
      type: Boolean,
    },
  },
  mixins: [filterable],
  computed: {
    // The set of filtered and sorted items as a 2D array
    itemArrayForExport() {
      let sortedItems = this.filterServerSide
        ? this.exportItems
        : this.filteredItems;
      if (sortedItems.length === 0) {
        if (this.headers === undefined) return [[]];
        return [this.headers.map((h) => h.text)];
      }
      if (this.pagination && this.pagination.sortBy) {
        let key = this.pagination.sortBy;
        //key has square braces hence removing first and last square braces from the key.
        key = key.replace(/^\[(.+)\]$/, '$1');
        let isDescending = this.pagination.descending;
        sortedItems = sortedItems.sort(function (a, b) {
          if (a[key] != null && b[key] != null) {
            if (isDescending) {
              return b[key]
                .toString()
                .localeCompare(a[key].toString(), undefined, { numeric: true });
            } else {
              return a[key]
                .toString()
                .localeCompare(b[key].toString(), undefined, { numeric: true });
            }
          }
        });
      }
      const headerKeys =
        this.headers != undefined
          ? this.headers
          : Object.keys(sortedItems[0]).map((value) => {
              const text = this.rename[value] || value;
              return { text, value };
            });
      return [
        headerKeys.map((h) => h.text),
        ...sortedItems.map((i) => {
          return headerKeys.map((k) => i[k.value]);
        }),
      ];
    },
  },
  watch: {
    isExportData() {
      this.exportCsv();
    },
  },
  methods: {
    exportTable() {
      if (this.filterServerSide) {
        this.$emit('export-server-side', true);
      } else {
        this.exportCsv();
      }
    },
    exportCsv() {
      exportCsv(this.itemArrayForExport, this.exportName);
      this.$emit('downloaded');
    },
  },
};
